export default "__VITE_ASSET__b6tclMlY__"